import { useState } from "react";
import { toast } from "sonner";
import { Loader2, ShieldCheck, Lock } from "lucide-react";
import { api, formatApiError } from "../lib/api";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "./ui/dialog";
import { Button } from "./ui/button";
import { Input } from "./ui/input";

export default function SetPinReminder({ open, onClose, onDone }) {
  const [pin, setPin] = useState("");
  const [confirm, setConfirm] = useState("");
  const [busy, setBusy] = useState(false);

  const save = async (e) => {
    e.preventDefault();
    if (!/^\d{4,6}$/.test(pin)) { toast.error("PIN must be 4–6 digits"); return; }
    if (pin !== confirm) { toast.error("PINs don't match"); return; }
    setBusy(true);
    try {
      await api.put("/settings/pin", { pin });
      toast.success("Parent PIN set! Your grown-up zones are protected 🔒");
      onDone && onDone();
      onClose();
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail));
    } finally { setBusy(false); }
  };

  return (
    <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="rounded-3xl max-w-md" data-testid="set-pin-reminder">
        <DialogHeader>
          <div className="mx-auto h-14 w-14 rounded-2xl bg-gradient-to-br from-[#2EC4B6] to-[#2AB7CA] text-white flex items-center justify-center mb-2">
            <ShieldCheck className="h-7 w-7" />
          </div>
          <DialogTitle className="font-display text-2xl text-center">Protect the grown-up zone</DialogTitle>
          <DialogDescription className="text-center">
            Set a Parent PIN so only you can open the Marketplace, Family feed and Parent Zone. You can change it later.
          </DialogDescription>
        </DialogHeader>
        <form onSubmit={save} className="space-y-3 mt-2">
          <div className="relative">
            <Lock className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-slate-400" />
            <Input data-testid="reminder-pin-input" value={pin} onChange={(e) => setPin(e.target.value.replace(/\D/g, ""))}
              inputMode="numeric" maxLength={6} placeholder="Choose a 4–6 digit PIN"
              className="rounded-xl h-12 pl-10 tracking-[0.4em] font-mono" />
          </div>
          <Input data-testid="reminder-pin-confirm" value={confirm} onChange={(e) => setConfirm(e.target.value.replace(/\D/g, ""))}
            inputMode="numeric" maxLength={6} placeholder="Confirm PIN"
            className="rounded-xl h-12 tracking-[0.4em] font-mono" />
          <Button type="submit" data-testid="reminder-pin-save" disabled={busy}
            className="w-full h-12 rounded-xl font-bold bg-[#2EC4B6] hover:bg-[#25a99d] text-white">
            {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : "Set my PIN"}
          </Button>
          <button type="button" data-testid="reminder-pin-later" onClick={onClose}
            className="block mx-auto text-sm font-semibold text-slate-400 hover:text-slate-600">
            Maybe later
          </button>
        </form>
      </DialogContent>
    </Dialog>
  );
}
